/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Open360BusinessLogicInventoryModelsProductLink } from './open360BusinessLogicInventoryModelsProductLink';
import { Open360BusinessLogicInventoryModelsProductVariantUpdateRequest } from './open360BusinessLogicInventoryModelsProductVariantUpdateRequest';


export interface Open360BusinessLogicInventoryModelsProductUpdateRequest {
    ID?: string;
    Title?: string;
    Description?: string;
    NfcCode?: string;
    Brand?: string;
    ItemTypeID?: number;
    ClassificationCategoryID?: number;
    /**
     * 1 = Male, 2 = Female
     */
    Gender?: Open360BusinessLogicInventoryModelsProductUpdateRequest.GenderEnum;
    Variants?: Array<Open360BusinessLogicInventoryModelsProductVariantUpdateRequest>;
    Links?: Array<Open360BusinessLogicInventoryModelsProductLink>;
    VerificationRequired?: boolean;
    CurrencyCode?: string;
    CurrencySign?: string;
    Source?: string;
    Preparation?: string;
    Ingredients?: string;
    FoodPreferences?: Array<number>;
    Allergens?: Array<number>;
}
export namespace Open360BusinessLogicInventoryModelsProductUpdateRequest {
    export type GenderEnum = 1 | 2;
    export const GenderEnum = {
        NUMBER_1: 1 as GenderEnum,
        NUMBER_2: 2 as GenderEnum
    }
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/open360BusinessLogicInventoryModelsProductUpdateRequest.ts